













import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import LogAnalysisMainTable from "./LogAnalysisMainTable.vue";
// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsLogAnalysisScheduleStatusResData } from "@/model/communication/logAnalysis/FetchInstallationsLogAnalysisScheduleStatusResData";
import {
    FetchInstallationsLogAnalysisScheduleStatusCommand,
    FetchInstallationsLogAnalysisScheduleStatusReqData,
} from "@/model/communication/logAnalysis/FetchInstallationsLogAnalysisScheduleStatusCommand";

export default Vue.extend({
    components: {
        StandardPage,
    },
    data() {
        return {
            LogAnalysisMainTable,
            routes,
            dataTableItemsPerPage,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
            loadingSummary: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: FetchInstallationsLogAnalysisScheduleStatusResData = await new FetchInstallationsLogAnalysisScheduleStatusCommand(request).execute();
                this.loading = false;

                //console.log("response: ", response);
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    created() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsLogAnalysisScheduleStatusReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
